const getReadOnlyStatus = (rootState) => rootState.ws.readOnly;

export default getReadOnlyStatus;
